export const LOG_TYPES = Object.freeze({
  CLEAR: 'Clear',
  INFO: 'Info',
  WARN: 'Warning',
  DEBUG: 'Debug',
  ERROR: "Error",
  CRITICAL: "Critical",
});
